import * as actionTypes from '../actions/actionTypes';
import {addDays, endOfMonth, format, startOfMonth} from "date-fns";
// import dataObjectFromFile from "../assets/mock/1/state0.json";


const today = new Date()

const inicioMes =  startOfMonth(today);
const fimMes = endOfMonth(today);

let auxpreviousMonthEnd = new Date().setDate(0);


const inicioMesAnterior =  startOfMonth(auxpreviousMonthEnd);
const mesmoDiaNoMesAnterior = new Date(inicioMesAnterior.getFullYear(),
                 inicioMesAnterior.getMonth(), today.getDate(),
    23,59,59);


//pastDay.setDate(today.getDate() - 90)



const initialState = () => {


    const at = localStorage.getItem('accessToken');
    // if (at && at == "mock") {
    //     // console.log("filterReducer initialState mocking", dataObjectFromFile.filter);
    //     // return {
    //     //     ...dataObjectFromFile.filter
    //     // }
    // }

    const aEstab = localStorage.getItem('estabelecimentos') !== null? JSON.parse(localStorage.getItem('estabelecimentos')) : [];
    let estabId = localStorage.getItem('estabId') !== null? localStorage.getItem('estabId') * 1 : 98;
    if (estabId === 0) { estabId = 96; }


    return {
        estabelecimentos:  aEstab,
        estabelecimentoId: estabId ,
        estabelecimentosLoading: false,
        error: false,
        periodMin: inicioMes.toISOString(), // '2024-02-01T03:00:00.000Z',//inicioMes.toISOString(), // format(inicioMes,'yyyy-MM-ddTHH:mm:ss.SSSZ'),
        periodMax: fimMes.toISOString(), // '2024-03-01T03:00:00.000Z', //fimMes.toISOString(), // format(fimMes, 'yyyy-MM-ddTHH:mm:ss.SSSZ'),
        // beforeperiodMin: pastDay.toISOString().substring(0, 10),
        // beforeperiodMax: today.toISOString().substring(0, 10),
        benchperiodMin: '2024-01-01T03:00:00.000Z', //inicioMesAnterior.toISOString(), //format(inicioMesAnterior,'yyyy-MM-ddTHH:mm:ss.SSSZ'),
        benchperiodMax: '2024-02-01T03:00:00.000Z', //mesmoDiaNoMesAnterior.toISOString() //format(mesmoDiaNoMesAnterior, 'yyyy-MM-ddTHH:mm:ss.SSSZ')
    }
}

const filtersReducer = (state = initialState(), action) => {


    switch (action.type) {
        case actionTypes.CHANGE_FILTER:

            return {...state, ...action.payload};

        case actionTypes.FETCH_ESTABELECIMENTOS:
            return {
                ...state,
                estabelecimentosLoading: true
            }
        case actionTypes.RECEIVE_ESTABELECIMENTOS:


            if (action.payload.error) {
                return {
                    ...state,
                    error: true
                }
            }
            localStorage.setItem('estabelecimentos', JSON.stringify(action.payload));

            if ( action.payload.length > 0 && (state.estabelecimentoId === 0 || state.estabelecimentoId > 90)
                ) {
                console.log("filterReducer.receiveEstabelecimento estabId = ", action.payload[0].id);
                localStorage.setItem('estabId', action.payload[0].id);
            }

            return {
                ...state,
                estabelecimentos: action.payload,
                estabelecimentoId: localStorage.getItem('estabId') ,
                estabelecimentosLoading: false
            }

        case actionTypes.SET_FILTER_ESTABELECIMENTO:

            localStorage.setItem('estabId', action.payload);
            return {
                ...state,
                estabelecimentoId: action.payload
            }

        default:
            return state;
    }
};

export default filtersReducer;
